import { StatesModule } from '@uirouter/angular';
import { FiHomePostCommentState, FiHomePostState, FiHomeState, FiModuleState } from '@fi-app/home/states/home-state';
import { FiPostViewState } from '@fi-app/home/states/post-view';
import { FiAddPostMobileAppState } from '@fi-app/home/states/add-post-mobile-app';

export const FiHomeStates: StatesModule = {
    states: [
        FiHomeState,
        FiHomePostState,
        FiHomePostCommentState,
        FiModuleState,
        FiPostViewState,
        FiAddPostMobileAppState,
    ],
};
